import produce from 'immer'
import { forEach, get } from 'lodash-es'

export const types = {
  SELECT_HIGH_SCHOOL: 'SELECT_HIGH_SCHOOL',
  MATCH_BY_EMAIL_FAILURE: 'MATCH_BY_EMAIL_FAILURE',
  TRY_OTHER_EMAIL: 'TRY_OTHER_EMAIL',
  FOUND_MATCH: 'FOUND_MATCH',
  SEND_INVITE: 'SEND_INVITE',
  SEND_UNMATCHED_INVITE: 'SEND_UNMATCHED_INVITE',
  CONFIRM_MATCH_TO_CLEVER_SCHOOL: 'CONFIRM_MATCH_TO_CLEVER_SCHOOL',
  CONFIRM_MATCH_TO_CLASSLINK_SCHOOL: 'CONFIRM_MATCH_TO_CLASSLINK_SCHOOL',
  CONFIRM_MATCH_TO_GOOGLE_SCHOOL: 'CONFIRM_MATCH_TO_GOOGLE_SCHOOL',
  EMAIL_SIGN_UP: 'EMAIL_SIGN_UP',
  MIDDLE_SCHOOL_SIGN_UP: 'MIDDLE_SCHOOL_SIGN_UP',
}

const studentSignupReducer = (state, action) => {
  switch (action.type) {
    case types.SELECT_HIGH_SCHOOL: {
      const cleverRequired = get(action.payload.highSchool, 'CleverRequired')
      const classLinkRequired = get(action.payload.highSchool, 'ClassLinkRequired')
      const googleRequired = get(action.payload.highSchool, 'GoogleRequired')
      let signUpStep
      if (cleverRequired) {
        signUpStep = 'CleverRequired'
      } else if (classLinkRequired) {
        signUpStep = 'ClassLinkRequired'
      } else if (googleRequired) {
        signUpStep = 'GoogleRequired'
      } else {
        signUpStep = 'EmailMatch'
      }

      return {
        ...state,
        signUpStep,
        data: produce(state.data, (draftData) => {
          draftData.highSchool = action.payload.highSchool
        }),
      }
    }
    case types.MATCH_BY_EMAIL_FAILURE: {
      return {
        ...state,
        signUpStep: 'IdDobMatch',
        data: produce(state.data, (draftData) => {
          draftData.email = action.payload.email
        }),
      }
    }
    case types.EMAIL_SIGN_UP: {
      return {
        ...state,
        signUpStep: 'EmailSignUp',
        data: produce(state.data, (draftData) => {
          draftData.highSchool = action.payload.highSchool
        }),
      }
    }
    case types.MIDDLE_SCHOOL_SIGN_UP: {
      return {
        ...state,
        signUpStep: 'MiddleSchoolSignUp',
      }
    }
    case types.TRY_OTHER_EMAIL: {
      return {
        ...state,
        signUpStep: 'EmailMatch',
      }
    }
    case types.FOUND_MATCH: {
      return {
        ...state,
        signUpStep: 'MatchConfirm',
        data: produce(state.data, (draftData) => {
          forEach(action.payload.matchIdentifiers, (val, key) => {
            draftData[key] = val
          })
          draftData.matchedStudent = action.payload.matchedStudent
        }),
      }
    }
    case types.SEND_INVITE: {
      return {
        ...state,
        signUpStep: 'StudentInvite',
        data: produce(state.data, (draftData) => {
          draftData.matchedStudent = action.payload.matchedStudent
        }),
      }
    }
    case types.SEND_UNMATCHED_INVITE: {
      return {
        ...state,
        signUpStep: 'UnmatchedStudentInvite',
        data: produce(state.data, (draftData) => {
          draftData.matchedStudent = action.payload.matchedStudent
        }),
      }
    }
    case types.CONFIRM_MATCH_TO_CLEVER_SCHOOL: {
      return {
        ...state,
        signUpStep: 'CleverRequired',
      }
    }
    case types.CONFIRM_MATCH_TO_CLASSLINK_SCHOOL: {
      return {
        ...state,
        signUpStep: 'ClassLinkRequired',
      }
    }
    case types.CONFIRM_MATCH_TO_GOOGLE_SCHOOL: {
      return {
        ...state,
        signUpStep: 'GoogleRequired',
      }
    }
    default:
      throw new Error(`action type '${action.type}' is not a valid type`)
  }
}

export default studentSignupReducer
